import { toast } from 'sonner';
import { API } from '../../../config/api';
import { DataService } from '../../../config/dataService/dataService';

// Personal details fetch
export const personalDetails = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.account.personal.getPersonalDetail);
        if (!response.data.error) {
            dispatch({
                type: API.account.personal.getPersonalDetail,
                personalDetailsData: response.data.data,
                loading: false,
            });
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const getCountryMasterListApi = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.account.personal.countryMasterList);
        if (!response.data.error) {
            dispatch({
                type: API.account.personal.countryMasterList,
                countryMasterList: response.data.data,
                loading: false,
            });
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const getPasswordUpdate = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.auth.passwordUpdate);
        if (!response.data.error) {
            dispatch({
                type: API.auth.passwordUpdate,
                passwordUpdate: response.data.data,
                loading: false,
            });
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

// Update personal details
export const updatePersonalDetails = (payload) => async () => {
    try {
        const response = await DataService.put(API.account.personal.updatePersonalDetail, payload);
        if (!response.data.error) {
            toast.success(response?.data?.message);
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

//Get Thanku details
export const updateSmsNotificationNumberApi = async (payload) => {
    try {
        const response = await DataService.put(API.account.personal.smsPhoneNumber, payload);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

//Get Thanku details
export const emailThankuDetails = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.account.personal.getThankyouDetail);
        if (!response.data.error) {
            dispatch({
                type: API.account.personal.getThankyouDetail,
                thankyouDetailData: response.data.data,
                loading: false,
            });
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

// Update Thankyou details
export const updateEmailThankuDetails = (payload) => async () => {
    try {
        const response = await DataService.put(API.account.personal.updateThankyouDetail, payload);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
// send text thanku email
export const sendTestThankuEmail = (payload) => async () => {
    try {
        const response = await DataService.post(API.account.personal.sendThankyouDetail, payload);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
